import { z } from "zod";
import { prompt } from "./prompt.js";

/** What kind of thing a metric counts. */
export const metricTargetType = z.enum(["prompt", "vault"]);
export type MetricTargetType = z.infer<typeof metricTargetType>;

/** The tracked interaction. Prompts are "copied" or "launched" (opened in an
 *  LLM chat); vault links are "opened". */
export const metricEvent = z.enum(["copied", "opened", "launched"]);
export type MetricEvent = z.infer<typeof metricEvent>;

/** A published prompt paired with how many times it's been copied. */
export const promptMetric = z.object({
  prompt,
  count: z.number().int().nonnegative(),
});
export type PromptMetric = z.infer<typeof promptMetric>;

/** Lightweight leaderboard row for the dashboard metrics panel. */
export const metricLeader = z.object({
  id: z.string(),
  label: z.string(),
  useCase: z.string().optional(),
  count: z.number().int().nonnegative(),
});
export type MetricLeader = z.infer<typeof metricLeader>;

/** Aggregate metrics snapshot for the dashboard Overview. */
export const metricsSummary = z.object({
  prompts: z.object({
    totalCopies: z.number().int().nonnegative(),
    top: z.array(metricLeader),
  }),
  vault: z.object({
    totalOpens: z.number().int().nonnegative(),
    top: z.array(metricLeader),
  }),
});
export type MetricsSummary = z.infer<typeof metricsSummary>;

/** Response envelope for the public "most reached for" strip. */
export const topPromptsResult = z.object({
  items: z.array(promptMetric),
});
export type TopPromptsResult = z.infer<typeof topPromptsResult>;

/** Query for the top-prompts endpoint. */
export const topPromptsQuery = z.object({
  limit: z.coerce.number().int().min(1).max(20).default(5),
});
export type TopPromptsQuery = z.infer<typeof topPromptsQuery>;
